import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function LocalLogo({ width, height }) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 79.06 46.48"
      width={width}
      height={height}
    >
      <defs>
        <clipPath id="clip-path">
          <path
            className="localAnzac-cls-1"
            d="M20.88,106a201.76,201.76,0,0,0,46.31.54,201.3,201.3,0,0,0,45.19-10.16L114.24,114a195,195,0,0,1-44.78,10.12,205.33,205.33,0,0,1-46.72-.51Z"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <polygon
            className="localAnzac-cls-1"
            points="113.09 95.46 136.16 93.04 129.96 102.3 138.02 110.71 114.95 113.13 113.09 95.46"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <polygon
            className="localAnzac-cls-1"
            points="21.86 107.67 -1.21 105.25 4.99 114.51 -3.07 122.92 20 125.34 21.86 107.67"
          />
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            className="localAnzac-cls-1"
            d="M104.07,98.13q1.16-2.94,2.87-3.61c1.7-.66,1.66-1.28,2.66-1.28s1.21-.12,1.91,1.54c.46,1.11.54,3.23.24,6.38a26.08,26.08,0,0,1-6.7-.51C103.82,100.29,103.49,99.45,104.07,98.13Z"
          />
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            className="localAnzac-cls-1"
            d="M118.52,98.15c-.78-2-1.73-3.17-2.87-3.61-1.7-.66-1.67-1.28-2.67-1.28s-1.21-.12-1.9,1.54c-.46,1.11-.54,3.23-.24,6.38a26.18,26.18,0,0,0,6.7-.51C118.77,100.3,119.09,99.46,118.52,98.15Z"
          />
        </clipPath>
        <clipPath id="clip-path-6">
          <path
            className="localAnzac-cls-1"
            d="M108.69,108q-2.94-1.17-3.6-2.88c-.66-1.71-1.28-1.67-1.28-2.67s-.11-1.22,1.54-1.92q1.65-.69,6.35-.24a26.83,26.83,0,0,1-.5,6.72C110.83,108.21,110,108.54,108.69,108Z"
          />
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            className="localAnzac-cls-1"
            d="M113.7,107.74q2.94-1.17,3.6-2.88c.66-1.71,1.28-1.67,1.28-2.67s.11-1.22-1.54-1.91q-1.65-.7-6.35-.24a26.93,26.93,0,0,0,.5,6.72C111.56,108,112.39,108.32,113.7,107.74Z"
          />
        </clipPath>
        <clipPath id="clip-path-8">
          <path
            className="localAnzac-cls-1"
            d="M113.06,100.84c.07.09.35.79-.08.86s-.34.58-.55.58-.42.72-.53.52-.22,0-1,0c-.5,0-.79-.09-.87-.26-.7-.29-1-.59-.92-.91a2.15,2.15,0,0,0-.07-1.08c0-.3.07-.39.26-.59s-.1-.09.08-.32.56-.06.48-.38.2-.41.75-.59c.85-.11,1.37,0,1.56.2s.52-.16.56.2a1.22,1.22,0,0,0,.31.66c.21.41.26.68.15.82S113,100.76,113.06,100.84Z"
          />
        </clipPath>
        <clipPath id="clip-path-9">
          <rect
            className="localAnzac-cls-2"
            x="-27.21"
            y="84.24"
            width="4"
            height="20"
          />
        </clipPath>
        <clipPath id="clip-path-10">
          <rect
            className="localAnzac-cls-2"
            x="21.79"
            y="84.24"
            width="4"
            height="20"
          />
        </clipPath>
        <clipPath id="clip-path-11">
          <path
            className="localAnzac-cls-1"
            d="M7.68,100.53A3.87,3.87,0,0,1,8,98.93a3.79,3.79,0,0,1,.85-1.21,4,4,0,0,1,1.26-.81,6.66,6.66,0,0,1,1.55-.44L14.92,96a1.23,1.23,0,0,0,.78-.33,1,1,0,0,0,.22-.62,1.67,1.67,0,0,0-.55-1.23,2.37,2.37,0,0,0-1.68-.53,2.4,2.4,0,0,0-1.82.65,2.44,2.44,0,0,0-.72,1.53L8,94.76a4.58,4.58,0,0,1,.49-1.58,5.21,5.21,0,0,1,1.11-1.42,5.54,5.54,0,0,1,1.73-1,6.62,6.62,0,0,1,2.37-.39,7.53,7.53,0,0,1,2.67.44,4.82,4.82,0,0,1,1.78,1.13,4,4,0,0,1,1,1.63,5.75,5.75,0,0,1,.3,1.94l0,6.62c0,.37,0,.76.05,1.17s.07.73.1,1l-3.28,0a5.12,5.12,0,0,1-.09-.75c0-.32,0-.6,0-.86A4.73,4.73,0,0,1,14.65,104a4.4,4.4,0,0,1-2.43.59,5,5,0,0,1-1.9-.35,4.38,4.38,0,0,1-1.44-.91,3.85,3.85,0,0,1-.9-1.29A3.92,3.92,0,0,1,7.68,100.53ZM13,101.9a3.93,3.93,0,0,0,1.09-.15,2.26,2.26,0,0,0,.93-.52,2.55,2.55,0,0,0,.65-1,3.77,3.77,0,0,0,.25-1.49v-.6l-3,.45a2.35,2.35,0,0,0-1.17.5,1.45,1.45,0,0,0-.48,1.19,1.56,1.56,0,0,0,.43,1.08A1.69,1.69,0,0,0,13,101.9Z"
          />
        </clipPath>
        <clipPath id="clip-path-12">
          <path
            className="localAnzac-cls-1"
            d="M-8.32,94.59a.14.14,0,0,1,0-.06,6.7,6.7,0,0,0-1.45-2.26A6.74,6.74,0,0,0-12,90.78a7,7,0,0,0-2.76-.54,7,7,0,0,0-2.76.52,6.62,6.62,0,0,0-2.22,1.47,6.73,6.73,0,0,0-1.46,2.25,7.84,7.84,0,0,0-.54,2.87,7.58,7.58,0,0,0,.52,2.86,7,7,0,0,0,1.44,2.26,6.56,6.56,0,0,0,2.21,1.5,7.18,7.18,0,0,0,2.75.55A7.26,7.26,0,0,0-12,104a6.63,6.63,0,0,0,2.21-1.49,6.78,6.78,0,0,0,1.46-2.25l0-.06a9.52,9.52,0,0,1-.38-2.8,9.59,9.59,0,0,1,.4-2.81m-3.38,4.47a3.66,3.66,0,0,1-.75,1.19,3.1,3.1,0,0,1-1.08.72,3.44,3.44,0,0,1-1.26.24,3.32,3.32,0,0,1-1.27-.26,2.89,2.89,0,0,1-1.07-.72,3.59,3.59,0,0,1-.74-1.2,4.47,4.47,0,0,1-.27-1.67,4.4,4.4,0,0,1,.29-1.66,3.54,3.54,0,0,1,.74-1.19A3,3,0,0,1-16,93.79a3.29,3.29,0,0,1,1.27-.24,3.26,3.26,0,0,1,1.26.25,3,3,0,0,1,1.08.73,3.62,3.62,0,0,1,.73,1.19,4.5,4.5,0,0,1,.28,1.67,4.45,4.45,0,0,1-.29,1.67"
          />
        </clipPath>
        <clipPath id="clip-path-13">
          <path
            className="localAnzac-cls-1"
            d="M.24,93.66a3.51,3.51,0,0,0-1.31.24,3.26,3.26,0,0,0-1.07.72,3.62,3.62,0,0,0-.73,1.19,4.76,4.76,0,0,0-.28,1.61A4.51,4.51,0,0,0-2.88,99a3.66,3.66,0,0,0,.73,1.21,3.16,3.16,0,0,0,1.08.74,3.31,3.31,0,0,0,1.3.25,3.21,3.21,0,0,0,1.2-.2,3,3,0,0,0,.91-.53,2.75,2.75,0,0,0,.6-.73,3.36,3.36,0,0,0,.34-.8l3.15,1.08a6.19,6.19,0,0,1-.72,1.66,6,6,0,0,1-1.28,1.44,6.45,6.45,0,0,1-1.84,1,6.77,6.77,0,0,1-2.37.39A6.93,6.93,0,0,1-2.51,104a6.51,6.51,0,0,1-2.22-1.5,7.12,7.12,0,0,1-1.47-2.26,7.39,7.39,0,0,1-.53-2.86,7.84,7.84,0,0,1,.54-2.87,6.78,6.78,0,0,1,1.46-2.25,6.7,6.7,0,0,1,2.19-1.47A6.78,6.78,0,0,1,.17,90.3a7,7,0,0,1,2.41.4,6.68,6.68,0,0,1,1.84,1,5.4,5.4,0,0,1,1.26,1.45,6.35,6.35,0,0,1,.69,1.68L3.16,96a3.68,3.68,0,0,0-.92-1.57,2.71,2.71,0,0,0-2-.72"
          />
        </clipPath>
        <clipPath id="clip-path-14">
          <rect
            className="localAnzac-cls-2"
            x="-27.21"
            y="84.46"
            width="126.78"
            height="30.78"
          />
        </clipPath>
        <clipPath id="clip-path-15">
          <path
            className="localAnzac-cls-1"
            d="M18,120.5a4,4,0,0,1,2.11-2.4c1.25-.45,1.22-.86,1.95-.86s.89-.08,1.4,1a9.25,9.25,0,0,1,.17,4.25,20.69,20.69,0,0,1-4.9-.34C17.81,121.94,17.57,121.38,18,120.5Z"
          />
        </clipPath>
        <clipPath id="clip-path-16">
          <path
            className="localAnzac-cls-1"
            d="M28.59,120.51a4,4,0,0,0-2.1-2.4c-1.25-.44-1.22-.86-2-.86s-.88-.08-1.39,1a9.36,9.36,0,0,0-.18,4.25,20.79,20.79,0,0,0,4.91-.34Q29.22,121.83,28.59,120.51Z"
          />
        </clipPath>
        <clipPath id="clip-path-17">
          <path
            className="localAnzac-cls-1"
            d="M21.38,127.05a4.21,4.21,0,0,1-2.63-1.92c-.49-1.14-.94-1.11-.94-1.78s-.09-.81,1.12-1.28a12.17,12.17,0,0,1,4.66-.15,16.19,16.19,0,0,1-.37,4.48C23,127.22,22.34,127.44,21.38,127.05Z"
          />
        </clipPath>
        <clipPath id="clip-path-18">
          <path
            className="localAnzac-cls-1"
            d="M25.06,126.91A4.27,4.27,0,0,0,27.7,125c.48-1.14.93-1.12.93-1.79s.09-.81-1.12-1.27a12.32,12.32,0,0,0-4.66-.16,16.14,16.14,0,0,0,.37,4.48C23.49,127.07,24.1,127.29,25.06,126.91Z"
          />
        </clipPath>
        <clipPath id="clip-path-19">
          <path
            className="localAnzac-cls-1"
            d="M24.59,122.31c.05,0,.26.52-.06.57s-.25.39-.4.39-.31.47-.39.34-.16,0-.72,0c-.37,0-.58-.06-.64-.17-.51-.19-.74-.4-.67-.61a1.36,1.36,0,0,0-.05-.72c0-.19.05-.26.19-.39s-.08-.06,0-.22.42,0,.36-.25.14-.27.55-.39c.62-.08,1,0,1.14.13s.38-.1.41.13a.81.81,0,0,0,.23.45c.15.27.19.45.11.54S24.53,122.25,24.59,122.31Z"
          />
        </clipPath>
        <clipPath id="clip-path-20">
          <path
            className="localAnzac-cls-1"
            d="M12.54,29A100.78,100.78,0,0,0,39.7,31.33a100.55,100.55,0,0,0,26.76-5.12l.66,12.34A97.54,97.54,0,0,1,40.6,43.66a102.59,102.59,0,0,1-27.4-2.35Z"
          />
        </clipPath>
        <clipPath id="clip-path-21">
          <rect
            className="localAnzac-cls-2"
            x="-8.67"
            y="-12.31"
            width="375"
            height="732"
          />
        </clipPath>
        <clipPath id="clip-path-22">
          <polygon
            className="localAnzac-cls-1"
            points="67.39 25.06 76.37 24.61 73.92 30.69 77.02 36.95 68.04 37.4 67.39 25.06"
          />
        </clipPath>
        <clipPath id="clip-path-24">
          <polygon
            className="localAnzac-cls-1"
            points="11.81 28.43 2.83 28.91 5.91 34.71 3.48 41.25 12.46 40.77 11.81 28.43"
          />
        </clipPath>
        <clipPath id="clip-path-26">
          <path
            className="localAnzac-cls-1"
            d="M61,26.59a4.13,4.13,0,0,1,2.14-2.41c1.22-.39,1.22-.83,1.92-.79s.85,0,1.27,1.14A10.46,10.46,0,0,1,66.24,29a18.61,18.61,0,0,1-4.67-.6C60.72,28.07,60.52,27.48,61,26.59Z"
          />
        </clipPath>
        <clipPath id="clip-path-28">
          <path
            className="localAnzac-cls-1"
            d="M71.09,27.13a4.08,4.08,0,0,0-1.87-2.61c-1.17-.53-1.13-1-1.82-1s-.85-.13-1.4,1A10.7,10.7,0,0,0,65.61,29a18.41,18.41,0,0,0,4.7-.11Q71.63,28.53,71.09,27.13Z"
          />
        </clipPath>
        <clipPath id="clip-path-30">
          <path
            className="localAnzac-cls-1"
            d="M63.85,33.58a4.11,4.11,0,0,1-2.42-2.13c-.4-1.21-.83-1.21-.79-1.91s0-.84,1.14-1.27a10.78,10.78,0,0,1,4.46.07,18.57,18.57,0,0,1-.6,4.65C65.34,33.83,64.74,34,63.85,33.58Z"
          />
        </clipPath>
        <clipPath id="clip-path-32">
          <path
            className="localAnzac-cls-1"
            d="M67.37,33.62A4.11,4.11,0,0,0,70,31.75c.53-1.17,1-1.12,1-1.81s.12-.84-1-1.39a10.73,10.73,0,0,0-4.44-.4,18.35,18.35,0,0,0,.11,4.69C65.86,33.71,66.43,34,67.37,33.62Z"
          />
        </clipPath>
        <clipPath id="clip-path-34">
          <path
            className="localAnzac-cls-1"
            d="M67.17,28.8c0,.06.22.56-.08.59s-.26.39-.41.38-.32.48-.39.35-.16,0-.69,0c-.35,0-.55-.09-.6-.22-.48-.22-.68-.44-.61-.66a1.43,1.43,0,0,0,0-.75c0-.21.06-.27.21-.4s-.07-.07.06-.22.4,0,.35-.25.16-.28.55-.38c.6-.05,1,0,1.08.19s.38-.09.39.16a.83.83,0,0,0,.19.48c.13.29.16.48.08.57S67.12,28.74,67.17,28.8Z"
          />
        </clipPath>
        <clipPath id="clip-path-36">
          <path
            className="localAnzac-cls-1"
            d="M9.84,39a2.8,2.8,0,0,1,1.56-1.59c.9-.26.89-.55,1.41-.53s.62,0,.94.77a6.39,6.39,0,0,1,0,3,14.22,14.22,0,0,1-3.42-.42C9.66,40,9.52,39.55,9.84,39Z"
          />
        </clipPath>
        <clipPath id="clip-path-38">
          <path
            className="localAnzac-cls-1"
            d="M17.27,39.36a2.83,2.83,0,0,0-1.39-1.75c-.86-.35-.82-.64-1.34-.67s-.62-.08-1,.67a6.34,6.34,0,0,0-.28,2.94,14.87,14.87,0,0,0,3.45,0Q17.66,40.29,17.27,39.36Z"
          />
        </clipPath>
        <clipPath id="clip-path-40">
          <path
            className="localAnzac-cls-1"
            d="M12,43.64a3,3,0,0,1-1.78-1.43c-.3-.81-.62-.81-.59-1.28s0-.56.83-.84a8.48,8.48,0,0,1,3.27.06,11,11,0,0,1-.42,3.1C13.07,43.81,12.64,43.94,12,43.64Z"
          />
        </clipPath>
        <clipPath id="clip-path-42">
          <path
            className="localAnzac-cls-1"
            d="M14.56,43.67a3,3,0,0,0,1.92-1.24c.38-.77.69-.74.72-1.2s.09-.56-.74-.93A8.76,8.76,0,0,0,13.2,40a11.34,11.34,0,0,0,.09,3.13C13.45,43.73,13.87,43.9,14.56,43.67Z"
          />
        </clipPath>
        <clipPath id="clip-path-44">
          <path
            className="localAnzac-cls-1"
            d="M14.4,40.46s.16.37-.06.39-.19.26-.3.26-.24.32-.29.22-.11,0-.5,0-.41-.06-.44-.15c-.35-.15-.5-.3-.45-.44a1,1,0,0,0,0-.51c0-.13,0-.17.15-.26s-.05-.05.05-.15.29,0,.25-.16.11-.18.4-.25c.44,0,.71,0,.8.13s.27-.06.28.11a.64.64,0,0,0,.14.32c.1.19.12.32.06.38S14.36,40.42,14.4,40.46Z"
          />
        </clipPath>
        <clipPath id="clip-path-46">
          <rect
            className="localAnzac-cls-2"
            x="12.33"
            y="6.69"
            width="2.85"
            height="15.36"
          />
        </clipPath>
        <clipPath id="clip-path-48">
          <rect
            className="localAnzac-cls-2"
            x="49.4"
            y="6.69"
            width="2.85"
            height="15.36"
          />
        </clipPath>
        <clipPath id="clip-path-50">
          <path
            className="localAnzac-cls-1"
            d="M38.7,19.3a3,3,0,0,1,.88-2.18,3.42,3.42,0,0,1,1-.63,5.3,5.3,0,0,1,1.17-.33l2.47-.37a.93.93,0,0,0,.59-.26.82.82,0,0,0,.17-.48,1.29,1.29,0,0,0-.42-1,1.81,1.81,0,0,0-1.27-.4,1.74,1.74,0,0,0-1.37.5,1.88,1.88,0,0,0-.55,1.18l-2.4-.54a3.56,3.56,0,0,1,.37-1.22,3.88,3.88,0,0,1,.84-1.1,4.24,4.24,0,0,1,1.31-.79,4.9,4.9,0,0,1,1.79-.3,5.41,5.41,0,0,1,2,.34,3.67,3.67,0,0,1,1.35.87,3.09,3.09,0,0,1,.75,1.27,4.71,4.71,0,0,1,.23,1.5l0,5.13c0,.28,0,.58,0,.9s0,.56.08.75H45.18c0-.14,0-.34-.07-.59a5,5,0,0,1,0-.66A3.6,3.6,0,0,1,44,22a3.35,3.35,0,0,1-1.84.46,3.7,3.7,0,0,1-1.44-.27,3.53,3.53,0,0,1-1.08-.7,2.92,2.92,0,0,1-.68-1A3.18,3.18,0,0,1,38.7,19.3Zm4,1.06a2.81,2.81,0,0,0,.82-.12,1.59,1.59,0,0,0,.7-.4,2.06,2.06,0,0,0,.5-.73A3.21,3.21,0,0,0,44.91,18v-.46l-2.27.35a1.72,1.72,0,0,0-.88.38,1.15,1.15,0,0,0-.36.92,1.2,1.2,0,0,0,1.3,1.22Z"
          />
        </clipPath>
        <clipPath id="clip-path-52">
          <path
            className="localAnzac-cls-1"
            d="M26.6,14.7a.43.43,0,0,1,0,0A5.4,5.4,0,0,0,25.5,12.9a5.17,5.17,0,0,0-3.75-1.57,5.33,5.33,0,0,0-2.09.4A5.2,5.2,0,0,0,18,12.87a5.37,5.37,0,0,0-1.1,1.74,6.19,6.19,0,0,0-.41,2.23,6.07,6.07,0,0,0,.39,2.21A5.4,5.4,0,0,0,18,20.8,4.78,4.78,0,0,0,19.62,22a5.39,5.39,0,0,0,4.17,0,4.76,4.76,0,0,0,1.67-1.15,5.4,5.4,0,0,0,1.11-1.74l0-.05a7.62,7.62,0,0,1-.29-2.16,7.71,7.71,0,0,1,.3-2.18m-2.55,3.46a2.8,2.8,0,0,1-.56.92,2.55,2.55,0,0,1-.82.56,2.64,2.64,0,0,1-1,.18,2.44,2.44,0,0,1-.95-.19,2.25,2.25,0,0,1-.82-.57,2.68,2.68,0,0,1-.55-.92,3.63,3.63,0,0,1-.21-1.29,3.35,3.35,0,0,1,.22-1.29,2.7,2.7,0,0,1,.56-.92,2.31,2.31,0,0,1,.82-.56,2.44,2.44,0,0,1,1.91,0,2.27,2.27,0,0,1,.81.56,2.85,2.85,0,0,1,.56.93,3.56,3.56,0,0,1,.21,1.29,3.63,3.63,0,0,1-.22,1.29"
          />
        </clipPath>
        <clipPath id="clip-path-54">
          <path
            className="localAnzac-cls-1"
            d="M33.07,14a2.53,2.53,0,0,0-1,.19,2.32,2.32,0,0,0-.8.56,2.53,2.53,0,0,0-.55.92,3.45,3.45,0,0,0-.21,1.25,3.53,3.53,0,0,0,.2,1.25,2.86,2.86,0,0,0,.55.93,2.52,2.52,0,0,0,.81.58,2.72,2.72,0,0,0,1,.19A2.59,2.59,0,0,0,34,19.7a2.44,2.44,0,0,0,.68-.42,2,2,0,0,0,.46-.57,2.86,2.86,0,0,0,.26-.61l2.38.84a4.9,4.9,0,0,1-.55,1.28,4.65,4.65,0,0,1-1,1.12,4.84,4.84,0,0,1-1.39.79,4.64,4.64,0,0,1-1.79.3A5.09,5.09,0,0,1,31,22a5,5,0,0,1-1.68-1.16,5.55,5.55,0,0,1-1.11-1.75,5.89,5.89,0,0,1-.4-2.22,6,6,0,0,1,.41-2.22,5,5,0,0,1,1.1-1.74A5,5,0,0,1,33,11.38a5.14,5.14,0,0,1,1.82.31,5.06,5.06,0,0,1,1.39.8,4.13,4.13,0,0,1,1,1.13,5.21,5.21,0,0,1,.52,1.29l-2.42.84a3,3,0,0,0-.7-1.21A2,2,0,0,0,33.07,14"
          />
        </clipPath>
        <clipPath id="clip-path-56">
          <rect
            className="localAnzac-cls-2"
            x="12.33"
            y="27.87"
            width="39.55"
            height="2.82"
          />
        </clipPath>
      </defs>
      <g className="localAnzac-cls-22">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-24"
            x="7.93"
            y="22.55"
            width="64"
            height="26.13"
            transform="translate(-1.81 2.14) rotate(-3)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-25">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-24"
            x="62.71"
            y="19.82"
            width="19"
            height="22.37"
            transform="translate(-1.52 3.82) rotate(-3)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-26">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-24"
            x="-1.86"
            y="23.65"
            width="19"
            height="22.37"
            transform="translate(-1.81 0.45) rotate(-3)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-27">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-28"
            x="55.91"
            y="18.22"
            width="15.51"
            height="15.71"
            transform="translate(34.29 88.29) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-29">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-30"
            x="60.72"
            y="18.49"
            width="15.51"
            height="15.71"
            transform="translate(38.58 93.34) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-31">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-30"
            x="55.5"
            y="23.13"
            width="15.68"
            height="15.54"
            transform="translate(29.16 92.54) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-32">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-28"
            x="60.32"
            y="23.24"
            width="15.68"
            height="15.54"
            transform="translate(33.63 97.45) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-33">
        <g className="localAnzac-cls-23">
          <rect
            x="59.38"
            y="22.17"
            width="12.93"
            height="12.96"
            transform="translate(33.79 92.9) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-34">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-28"
            x="4.98"
            y="31.54"
            width="13.67"
            height="14.19"
            transform="translate(-27.38 48.41) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-35">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-30"
            x="8.5"
            y="31.73"
            width="13.67"
            height="14.19"
            transform="translate(-24.23 52.11) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-36">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-30"
            x="4.7"
            y="34.82"
            width="13.79"
            height="14.06"
            transform="translate(-30.81 51.24) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-37">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-28"
            x="8.24"
            y="34.9"
            width="13.79"
            height="14.06"
            transform="translate(-27.54 54.85) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-38">
        <g className="localAnzac-cls-23">
          <rect
            x="7.45"
            y="34.27"
            width="11.96"
            height="12.17"
            transform="translate(-27.58 51.65) rotate(-87)"
          />
        </g>
      </g>
      <g className="localAnzac-cls-39">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-40"
            x="7.33"
            y="1.69"
            width="12.85"
            height="25.36"
          />
        </g>
      </g>
      <g className="localAnzac-cls-41">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-40"
            x="44.4"
            y="1.69"
            width="12.85"
            height="25.36"
          />
        </g>
      </g>
      <g className="localAnzac-cls-42">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-40"
            x="33.7"
            y="6.42"
            width="18.97"
            height="21.03"
          />
        </g>
      </g>
      <g className="localAnzac-cls-43">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-40"
            x="11.47"
            y="6.33"
            width="20.13"
            height="21.06"
          />
        </g>
      </g>
      <g className="localAnzac-cls-44">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-40"
            x="22.81"
            y="6.38"
            width="19.95"
            height="21.06"
          />
        </g>
      </g>
      <g className="localAnzac-cls-45">
        <g className="localAnzac-cls-23">
          <rect
            className="localAnzac-cls-46"
            x="7.33"
            y="22.87"
            width="49.55"
            height="12.82"
          />
        </g>
      </g>
      <text
        className="localAnzac-cls-47"
        transform="matrix(0.98, 0.19, -0.19, 0.98, 18.44, 38.19)"
      >
        L
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(21.79 38.84) rotate(8.36)"
      >
        e
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(25.11 39.32) rotate(6.12)"
      >
        s
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(27.88 39.61) rotate(4.35)"
      >
        t
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(30.07 39.77) rotate(3.03)"
      >
        {' '}
      </text>
      <text
        className="localAnzac-cls-47"
        transform="matrix(1, 0.01, -0.01, 1, 31.68, 39.91)"
      >
        W
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(37.64 39.9) rotate(-2.83)"
      >
        e
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(40.96 39.73) rotate(-4.53)"
      >
        {' '}
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(42.52 39.61) rotate(-6.24)"
      >
        F
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(45.71 39.27) rotate(-8.5)"
      >
        o
      </text>
      <text
        className="localAnzac-cls-47"
        transform="matrix(0.98, -0.18, 0.18, 0.98, 49.2, 38.73)"
      >
        r
      </text>
      <text
        className="localAnzac-cls-47"
        transform="translate(51.46 38.33) rotate(-12.54)"
      >
        g
      </text>
      <text
        className="localAnzac-cls-47"
        transform="matrix(0.97, -0.26, 0.26, 0.97, 54.94, 37.54)"
      >
        e
      </text>
      <text
        className="localAnzac-cls-47"
        transform="matrix(0.96, -0.29, 0.29, 0.96, 58.17, 36.67)"
      >
        t
      </text>
    </svg>
  );
}

LocalLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LocalLogo.defaultProps = {
  width: 50,
  height: 34,
};

export default LocalLogo;
